import { FormGroup } from 'arag-ui-lib';
import ids from '../../utils/constants/ids';
import { decode } from 'html-entities';
import codes from '../../utils/constants/codes';
import React from 'react';
import answer from '../../reducers/answer';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import tickIcon from '../../assets/images/tick.png';

type Props = {
    questionWithAnswer: any;
};

const QuestionWithAnswer = (props: Props) => {
    const { questionWithAnswer } = props;
    if (
        !questionWithAnswer ||
        !questionWithAnswer.question ||
        !questionWithAnswer.answer ||
        !questionWithAnswer.answer._parsedAnswerTextValue
    ) {
        return null;
    }

    let answerLabel = questionWithAnswer.answer._parsedAnswerTextValue;
    if (questionWithAnswer.question._questionTypeCode === codes.checkbox) {
        answerLabel = questionWithAnswer.answer._parsedAnswerTextValue ? (
            <img
                src={tickIcon}
                alt="ticked"
                style={{ marginRight: '8px', width: '20px' }}
            />
        ) : null;
    }
    return (
        <FormGroup
            labelSize={
                questionWithAnswer?.question.questionGroupStepId ===
                ids.declarationQuestionGroupStep
                    ? 'col-sm-7'
                    : 'col-sm-7'
            }
            inputSize={
                questionWithAnswer?.question.questionGroupStepId ===
                ids.declarationQuestionGroupStep
                    ? 'col-sm-5'
                    : 'col-sm-5'
            }
            label={questionWithAnswer.question.name}
            variant="plain"
            inputProps={{
                label:
                    typeof answerLabel === 'string'
                        ? decode(answerLabel, { scope: 'strict' })
                        : typeof answerLabel === 'object'
                          ? answerLabel
                          : GENERAL_FUNCTIONS.formatNumbers(
                                questionWithAnswer?.answer,
                            ),
            }}
        />
    );
};

export default QuestionWithAnswer;
